import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import { hasOnlyImmune } from 'const/enums/Modality';
var getIsImmuneOnly = function getIsImmuneOnly() {
  return function (state) {
    var _state$info$modalitie;
    return hasOnlyImmune((_state$info$modalitie = state.info.modalities) !== null && _state$info$modalitie !== void 0 ? _state$info$modalitie : []);
  };
};
export default createMemoizedSelector(getIsImmuneOnly);